/**
 * @file    payloadBuilder
 * @scope   SHARED
 * @summary Pure builders for the controller name and the request payload sent by both tables.
 * @consumes components/library
 * @produces resolveControllerName, buildFetchPayload
 * @sideEffects None.
 */
import { library } from 'components';

/** Returns the payload key matching `prop` case-insensitively, defaulting to `controllerName`. */
const getNonCaseSensitiveProp = (payload: any, prop: string) =>
  Object.keys(payload).find((key) => key.toLowerCase() === prop) || 'controllerName';

/** Resolves the controller to call, depending on the view and the payload controllerName. */
export const resolveControllerName = (payload: any, chartView: boolean) => {
  const viewName = chartView ? library.HORIZONTAL_BAR_CHART : library.DYNAMIC_TABLE;
  const controllerNameValue = payload[getNonCaseSensitiveProp(payload, 'controllername')];

  const ctrlChart = controllerNameValue ? `${controllerNameValue}Chart` : viewName;
  const ctrlTable = controllerNameValue ? `${controllerNameValue}` : viewName;

  return { controllerNameValue, controllerName: chartView ? ctrlChart : ctrlTable };
};

export interface FetchPayloadArgs {
  payload: any;
  controllerName: string;
  chartView: boolean;
  searchFilter: string;
  selectedValueL1: any;
  selectedValueL2: any;
  paginated: boolean;
  firstRender: boolean;
  page: number;
  perPage: number;
  selectedColumn: any;
  direction: string;
}

export const buildFetchPayload = ({
  payload,
  controllerName,
  chartView,
  searchFilter,
  selectedValueL1,
  selectedValueL2,
  paginated,
  firstRender,
  page,
  perPage,
  selectedColumn,
  direction,
}: FetchPayloadArgs) => {
  const chartFilters = [selectedValueL1?.value, selectedValueL2?.value];

  const GridFilters: any = chartView
    ? chartFilters
    : searchFilter
    ? { [selectedValueL1?.value]: searchFilter }
    : { Parameter: selectedValueL1?.value };

  const Filters: any = chartView
    ? chartFilters
    : searchFilter
    ? { [selectedValueL1?.value]: searchFilter }
    : [selectedValueL1?.value];

  // WHY: `current1` / `current2` are legacy markers the backend may rely on; kept verbatim.
  const newPayload: any = paginated
    ? {
        ...payload,
        page,
        perPage,
        selectedColumn,
        sortDirection: direction,
        ControllerName: controllerName,
        GridFilters,
        Filters,
        current1: firstRender,
      }
    : {
        ...payload,
        ControllerName: controllerName,
        GridFilters,
        Filters,
        current2: firstRender,
      };

  if (chartView) {
    delete newPayload.GridFilters;
  } else {
    delete newPayload.Filters;
  }
  return newPayload;
};
